// @flow
import React, { Component } from 'react';
import Lottie from './Lottie';
import styled from 'styled-components/macro';

const SectionLoaderLottie = styled(Lottie)`
  height: 55px;
`;

const SectionLoaderDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => (props.small ? '100px' : '300px')};
  width: 100%;
`;
type Props = { small?: boolean };

export default class SectionLoader extends Component<Props> {
  render() {
    return (
      <SectionLoaderDiv small={this.props.small}>
        <SectionLoaderLottie name="smaller-loader" loop />
      </SectionLoaderDiv>
    );
  }
}
